import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';

import {MovieCollectComponent} from './movie-collect.component';
import {MovieSearchComponent} from './movie-search/movie-search.component';
import {DialectMovieComponent} from './dialect-movie/dialect-movie.component';


const routes: Routes = [
  {
    path: 'movie-collect',
    component: MovieCollectComponent,
  },
  {
    path: 'movie-search',
    component: MovieSearchComponent,
  },
  {
    path: 'dialect-movie',
    component: DialectMovieComponent,
  }
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
  ],
})
export class MovieCollectRoutingModule {}
